<Modal title="Are you sure?" on:close={() => $uiState.activeModal = undefined} on:action={() => apply()}>
  Are you sure?
</Modal>

<script lang="ts">
  export let item :Offer_v2_Doc;

  import { uiState } from '../../../../../lib/uiState';
  import Modal from '../../../../_components/Modal.svelte';
  //import { createEventDispatcher } from 'svelte';

  //let confirmed = createEventDispatcher();

  async function apply() {
    let firebase = window.firebase;

    await firebase.firestore().collection('offers_v2').doc(item.id).delete();

    $uiState.activeModal = undefined;
  }

</script>